import React from "react";
import { useNavigate } from "react-router-dom";
import MoleculeInfo from "../ResultsTable/MoleculeInfo.js";
import InteractiveImage from "../ReactionTable/interactiveImage.js";
import ResultInfoText from "../ResultsTable/ResultInfoText.js";
import KingdomIcon from "../ReactionTable/kingdomIcon.js";
import { Link } from "react-router-dom";
import CopyTextUniversalButton from "../CopyTextUniversalButton.js";

const MoleculeCard = ({ molecule }) => {

    const navigate = useNavigate();
return (
    <Link to={`/record/${molecule.marts}`} style={{ textDecoration: 'none', color: 'inherit' }}>
    <div className="molecule-card">     
                     
        <InteractiveImage 
            src={`/mol_${molecule.id}.png`}
            alt={molecule.smiles}
            className={"responsive"}
            interactiveSearch={() => {}}
            showPopups={false}
            interactiveAdvancedSearch={() => {}}
            isQuickSearch={true}
            parameter={"reactSmiles"}
            maxWidth={"150px"}
            imageScale={"1"}
        />
        <MoleculeInfo molecule={molecule} interactiveSearch={() => {}} />
        {molecule.countInReactions && (
            <ResultInfoText 
                text={`Found in: ${molecule.countInReactions} reaction${molecule.countInReactions > 1 ? 's' : ''}`} 
                row={1} 
            />
        )}<div style={{ display: 'flex', flexWrap: 'wrap', gap: '2px' }}>
        {molecule.kingdoms && ([...molecule.kingdoms].sort().map((kingdom, index) => 
        (<KingdomIcon  row={`${molecule.marts}${index}`} isQuickSearch={true} interactiveSearch={() => {}}
        backgroundColor="rgb(245,245,245, 0)" kingdomVal={kingdom} speciesVal={` in ${molecule.kingdomCounts[kingdom]} reactions`}/>)))} </div>
    </div></Link>
);
};

export default MoleculeCard;